import React, { useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import CustomTableHead from "../../../components/layout/customComponents/customTableHead/customTableHead";
import CustomTableFooter from "../../../components/layout/customComponents/customTableFooter/customTableFooter";
import TableAction from "../../../components/layout/customComponents/customTableAction/customTableAction";
import DateUtils from "utils/dates/DateUtils";
import { doTruncarStr } from "utils/general/TruntecStr";
import { StyledTableRow } from "components/profiles/ProfileStyles";
import { stableSort } from "utils/tables/createContent";
import { getSorting } from "utils/tables/createContent";
import { TableOrdering } from "utils/tables/createContent";
import { handleSortRequest } from "./ScholarshipRecessesTableSort";
import { desc } from "./ScholarshipRecessesTableSort";
import { TableContainer } from "@material-ui/core";
import { Allow, Screen } from "global/constants";
import { GetGeneralPermissionForAction } from "utils/permissions/GetGeneralPermissionForAction";

export function ScholarshipsRecessesTable({ rows, attributes }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    rows.length > 10 ? 10 : rows.length
  );

  const [orderByIndex, setOrderByIndex] = useState(0);
  const [order, setOrder] = useState(TableOrdering.ASC);

  const handleSorting = index => {
    handleSortRequest(index, orderByIndex, setOrder, setOrderByIndex);
  };

  function handlePageChange(event, newPage) {
    setPage(newPage);
  }

  function handleRowsPerPageChange(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  return (
    <TableContainer>
      <Table>
        {rows.length > 0 && (
          <CustomTableHead
            attributes={attributes}
            order={order}
            orderBy={orderByIndex}
            handleRequestSort={handleSorting}
            rowsLength={rows.length}
          />
        )}

        <TableBody>
          {rows &&
            stableSort(
              rows,
              getSorting(order, attributes[orderByIndex].name, desc)
            )
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => {
                return (
                  <StyledTableRow key={row.contractId}>
                    <TableCell size="small" style={{ width: "40%" }}>
                      {row["collaboratorName"]
                        ? doTruncarStr(row["collaboratorName"], 40)
                        : "-"}
                    </TableCell>

                    <TableCell size="small" style={{ width: "10%" }}>
                      {row["admissionDate"]
                        ? DateUtils.formatString(
                            row["admissionDate"],
                            "DD/MM/YYYY"
                          )
                        : "-"}
                    </TableCell>

                    <TableCell
                      size="small"
                      align="right"
                      style={{ width: "15%" }}
                    >
                      <div
                        style={{
                          marginTop: "auto",
                          marginBottom: "auto",
                          display: "flex",
                          flexWrap: "nowrap ",
                          justifyContent: "flex-end",
                        }}
                      >
                        {GetGeneralPermissionForAction(
                          Screen.SCHOLARSHIP_RECESS_LIST,
                          Allow.READ
                        ) && (
                          <TableAction
                            type="view"
                            path={`/ScholarshipsRecesses/${row.id}/view`}
                          />
                        )}

                        {GetGeneralPermissionForAction(
                          Screen.SCHOLARSHIP_RECESS_LIST,
                          Allow.EDIT
                        ) && (
                          <TableAction
                            type="edit"
                            path={`/ScholarshipsRecesses/${row.id}/edit`}
                          />
                        )}
                      </div>
                    </TableCell>
                  </StyledTableRow>
                );
              })}
        </TableBody>

        {rows.length > 0 && (
          <CustomTableFooter
            rowsLength={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        )}
      </Table>
    </TableContainer>
  );
}
